export default __webpack_public_path__ + "static/media/SD-SignUp-Image.f5bfef22.png";